import Api from '../api'
export default ({
  state: {
    accountLedgerLists: [],
    journalBookLists: [],
    reversalBookLists: [],
    debitNoteBookLists: [],
    creditNoteBookLists: [],
    allJournalBookLists: [],
    allJournalVoidBookLists: [],
    allJournalPendingBookLists: [],
    paymentBookLists: [],
    receiptBookLists: [],
    bankTransferLists: [],
    cashDepositLists: [],
    cashWithDrawLists: []
  },
  mutations: {
    JOURNAL_BOOK_LIST(state, journalBookList) {
      state.journalBookLists = journalBookList
    },
    DEBIT_NOTE_BOOK_LIST(state, debitNoteBookList) {
      state.debitNoteBookLists = debitNoteBookList
    },
    CREDIT_NOTE_BOOK_LIST(state, creditNoteBookList) {
      state.creditNoteBookLists = creditNoteBookList
    },
    ALL_JOURNAL_BOOK_LIST(state, allJournalBookList) {
      state.allJournalBookLists = allJournalBookList
    },
    ALL_JOURNAL_VOID_BOOK_LIST(state, allJournalVoidBookList) {
      state.allJournalVoidBookLists = allJournalVoidBookList
    },
    ALL_JOURNAL_PENDING_BOOK_LIST(state, allJournalPendingBookList) {
      state.allJournalPendingBookLists = allJournalPendingBookList
    },
    PAYMENT_BOOK_LIST(state, paymentBookList) {
      state.paymentBookLists = paymentBookList
    },
    REVERSAL_BOOK_LIST(state, reversalBookList) {
      state.reversalBookLists = reversalBookList
    },
    RECEIPT_BOOK_LIST(state, receiptBookList) {
      state.receiptBookLists = receiptBookList
    },
    BANK_TRANSFER_LIST(state, bankTransferList) {
      state.bankTransferLists = bankTransferList
    },
    CASH_DEPOSIT_LIST(state, cashDepositList) {
      state.cashDepositLists = cashDepositList
    },
    CASH_WITHDRAW_LIST(state, cashWithDrawList) {
      state.cashWithDrawLists = cashWithDrawList
    },
    ACCOUNT_LEDGER_LIST(state, accountLedgerList) {
      state.accountLedgerLists = accountLedgerList
    },
    DELETE_JOURNAL_ENTRY(state, journal) {
      let journalList = state.journalBookLists.filter(deleteJournal => deleteJournal.id !== journal.id)
      state.journalBookLists = journalList
    },
    DELETE_RECEIPT_ENTRY(state, receipt) {
      let receiptList = state.receiptBookLists.filter(deleteReceipt => deleteReceipt.id !== receipt.id)
      state.receiptBookLists = receiptList
    },
    DELETE_PAYMENT_ENTRY(state, payment) {
      let paymentList = state.paymentBookLists.filter(deleteReceipt => deleteReceipt.id !== payment.id)
      state.paymentBookLists = paymentList
    },
    DELETE_CASH_DEPOSIT(state, cashDeposit) {
      let cashDepositList = state.cashDepositLists.filter(deleteCashDeposit => deleteCashDeposit.id !== cashDeposit.id)
      state.cashDepositLists = cashDepositList
    },
    DELETE_BANK_TRANSFER(state, bankTransfer) {
      let bankTransferList = state.bankTransferLists.filter(deleteBankTransfer => deleteBankTransfer.id !== bankTransfer.id)
      state.bankTransferLists = bankTransferList
    },
    DELETE_CASH_WITHDRAW(state, cashWithdraw) {
      let cashWithdrawList = state.cashWithDrawLists.filter(deleteCashWithdraw => deleteCashWithdraw.id !== cashWithdraw.id)
      state.cashWithDrawLists = cashWithdrawList
    },
    UPDATE_PAYMENT_ENTRY(state, updatedPayment) {
      state.paymentBookLists = state.paymentBookLists.map(payment => payment.id !== updatedPayment.id ? payment : {...payment, ...updatedPayment})
    },
    UPDATE_RECEIPT_ENTRY(state, updatedReceipt) {
      state.receiptBookLists = state.receiptBookLists.map(receipt => receipt.id !== updatedReceipt.id ? receipt : {...receipt, ...updatedReceipt})
    },
    UPDATE_JOURNAL_ENTRY(state, updateJournal) {
      state.journalBookLists = state.journalBookLists.map(journal => journal.id !== updateJournal.id ? journal : {...journal, ...updateJournal})
    },
    UPDATE_BANK_TRANSFER(state, updateBankTransfer) {
      state.bankTransferLists = state.bankTransferLists.map(bankTransfer => bankTransfer.id !== updateBankTransfer.id ? bankTransfer : {...bankTransfer, ...updateBankTransfer})
    },
    UPDATE_CASH_DEPOSIT(state, updateCashDeposit) {
      state.cashDepositLists = state.cashDepositLists.map(cashDeposit => cashDeposit.id !== updateCashDeposit.id ? cashDeposit : {...cashDeposit, ...updateCashDeposit})
    },
    UPDATE_CASH_WITHDRAW(state, updateCashWithdraw) {
      state.cashWithDrawLists = state.cashWithDrawLists.map(cashWithdraw => cashWithdraw.id !== updateCashWithdraw.id ? cashWithdraw : {...cashWithdraw, ...updateCashWithdraw})
    }
  },
  actions: {
    async loadAccountLedgerList ({commit}, ledger) {
      let response = await Api.request('get', '/accountingReport/accountLedger/' + this.getters.organisationId + '/' + ledger.accountMasterId + '/' + this.state.fyId + '/' + ledger.fromDate + '/' + ledger.toDate)
      let responseValue = response.data.data
      commit('ACCOUNT_LEDGER_LIST', responseValue)
      return response
    },
    async loadjournalBookList ({commit}, journal) {
      let response = await Api.request('get', '/accountingReport/journalBook/' +
      this.state.organisationid + '/' + journal.accountMasterId + '/' +
          this.state.fyId + '/' + journal.fromDate + '/' + journal.toDate + '/' + journal.type)
      let responseValue = response.data.data
      commit('JOURNAL_BOOK_LIST', responseValue)
      return response
    },
    async loadDebitNoteBookList ({commit}, journal) {
      let response = await Api.request('get', '/accountingReport/journalBook/' +
      this.state.organisationid + '/' + journal.accountMasterId + '/' +
          this.state.fyId + '/' + journal.fromDate + '/' + journal.toDate + '/' + journal.type)
      let responseValue = response.data.data
      commit('DEBIT_NOTE_BOOK_LIST', responseValue)
      return response
    },
    async loadCreditNoteBookList ({commit}, journal) {
      let response = await Api.request('get', '/accountingReport/journalBook/' +
      this.state.organisationid + '/' + journal.accountMasterId + '/' +
          this.state.fyId + '/' + journal.fromDate + '/' + journal.toDate + '/' + journal.type)
      let responseValue = response.data.data
      commit('CREDIT_NOTE_BOOK_LIST', responseValue)
      return response
    },
    async loadAlljournalBookList ({commit}, journal) {
      let response = await Api.request('get', '/accountingReport/journalBook/' +
      this.state.organisationid + '/' + journal.accountMasterId + '/' +
          this.state.fyId + '/' + journal.fromDate + '/' + journal.toDate + '/' + journal.type)
      let responseValue = response.data.data
      commit('ALL_JOURNAL_BOOK_LIST', responseValue)
      return response
    },
    async loadAlljournalVoidBookList ({commit}, journal) {
      let response = await Api.request('get', '/accountingReport/journalBookVoid/' +
      this.state.organisationid + '/' + journal.accountMasterId + '/' +
          this.state.fyId + '/' + journal.fromDate + '/' + journal.toDate + '/' + journal.type)
      let responseValue = response.data.data
      commit('ALL_JOURNAL_VOID_BOOK_LIST', responseValue)
      return response
    },
    async loadAllPendingjournalBookList ({commit}, journal) {
      let response = await Api.request('get', '/accountingReport/journalBookForMakerCheckerByType/' +
      this.state.organisationid + '/' + journal.accountMasterId + '/' +
          this.state.fyId + '/' + journal.fromDate + '/' + journal.toDate + '/' + journal.type + '/' + journal.makerCheckerType)
      let responseValue = response.data.data
      commit('ALL_JOURNAL_PENDING_BOOK_LIST', responseValue)
      return response
    },
    async loadReversalBookList ({commit}, journal) {
      let response = await Api.request('get', '/accountingReport/journalBook/' +
      this.state.organisationid + '/' + journal.accountMasterId + '/' +
          this.state.fyId + '/' + journal.fromDate + '/' + journal.toDate + '/' + journal.type)
      let responseValue = response.data.data
      commit('REVERSAL_BOOK_LIST', responseValue)
      return response
    },

    async loadReceiptBookList ({commit}, journal) {
      let response = await Api.request('get', '/accountingReport/journalBook/' +
      this.state.organisationid + '/' + journal.accountMasterId + '/' +
          this.state.fyId + '/' + journal.fromDate + '/' + journal.toDate + '/' + journal.type)
      let responseValue = response.data.data
      commit('RECEIPT_BOOK_LIST', responseValue)
      return response
    },
    async loadPaymentBookList ({commit}, journal) {
      let response = await Api.request('get', '/accountingReport/journalBook/' +
      this.state.organisationid + '/' + journal.accountMasterId + '/' +
          this.state.fyId + '/' + journal.fromDate + '/' + journal.toDate + '/' + journal.type)
      let responseValue = response.data.data
      commit('PAYMENT_BOOK_LIST', responseValue)
      return response
    },
    async loadBankTransferList ({commit}, bankTransfer) {
      let response = await Api.request('get', '/accountingReport/bankTransferRegister/' +
      this.state.organisationid + '/' +
          this.state.fyId + '/' + bankTransfer.fromDate + '/' + bankTransfer.toDate + '/' + bankTransfer.type)
      let responseValue = response.data.data
      commit('BANK_TRANSFER_LIST', responseValue)
      return response
    },
    async loadCashDepositList ({commit}, cashDeposit) {
      let response = await Api.request('get', '/accountingReport/cashDepositRegister/' +
      this.state.organisationid + '/' +
          this.state.fyId + '/' + cashDeposit.fromDate + '/' + cashDeposit.toDate + '/' + cashDeposit.type)
      let responseValue = response.data.data
      commit('CASH_DEPOSIT_LIST', responseValue)
      return response
    },
    async loadCashWithdrawList ({commit}, cashWithdraw) {
      let response = await Api.request('get', '/accountingReport/cashWithdrawRegister/' +
      this.state.organisationid + '/' +
          this.state.fyId + '/' + cashWithdraw.fromDate + '/' + cashWithdraw.toDate + '/' + cashWithdraw.type)
      let responseValue = response.data.data
      commit('CASH_WITHDRAW_LIST', responseValue)
      return response
    },
    async loadaccountLedger({commit}, journal) {
      let response = await Api.request('get', '/accountingReport/accountLedger/' + this.getters.organisationId + '/' + journal.tranId + '/' + journal.tranModuleType + '/' + this.state.fyId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async loadPartyStatement ({commit}, partystatement) {
      let response = await Api.request('get', '/accountingReport/partyStatement/' + this.getters.organisationId + '/' + partystatement.accountId + '/' + this.state.fyId + '/' + partystatement.fromDate + '/' + partystatement.toDate)
      // commit('PARTY_STATEMENT', response.data.data)
      return response
    },
    async loadCustomerSupplierTransactionSummary ({commit}, summary) {
      let response = await Api.request('get', '/accountingReport/supplierCustomerStatement/' + this.getters.organisationId + '/' + this.state.fyId + '/' + summary.fromDate + '/' + summary.toDate + '/' + summary.type)
      // commit('PARTY_STATEMENT', response.data.data)
      return response
    },
    async loadBankStatement ({commit}, summary) {
      let response = await Api.request('get', '/accountingReport/bankStatement/' + this.getters.organisationId + '/' + this.state.fyId + '/' + summary.bankId + '/' + summary.fromDate + '/' + summary.toDate)
      // commit('BANK_STATEMENT', response.data.data)
      return response
    },
    async loadPostDateCheque({commit}, summary) {
      let response = await Api.request('get', '/accountingReport/bankPdcTransaction/' + this.getters.organisationId + '/' + this.getters.fyId + '/' + summary.bankId + '/' + summary.fromDate + '/' + summary.toDate + '/All')
      // if (response.data.status === 'SUCCESS') {
      return response
      // }
    },
    async loadPostDateChequeCleared({commit}, summary) {
      let response = await Api.request('get', '/accountingReport/bankPdcTransaction/' + this.getters.organisationId + '/' + this.getters.fyId + '/' + summary.bankId + '/' + summary.fromDate + '/' + summary.toDate + '/clear')
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async loadPostDateChequeUnCleared({commit}, summary) {
      let response = await Api.request('get', '/accountingReport/bankPdcTransaction/' + this.getters.organisationId + '/' + this.getters.fyId + '/' + summary.bankId + '/' + summary.fromDate + '/' + summary.toDate + '/unclear')
      return response
    },
    async loadCashBook ({commit}, summary) {
      let response = await Api.request('get', '/accountingReport/cashBook/' + this.getters.organisationId + '/' + this.state.fyId + '/' + summary.accountId + '/' + summary.fromDate + '/' + summary.toDate)
      // commit('CASH_BOOK', response.data.data)
      return response
    },
    async searchPLReport({commit}, toDate) {
      let response = await Api.request('get', '/finalReport/profitAndLoss/' + this.getters.organisationId + '/' + this.getters.fyId + '/' + toDate)
      commit('PLREPORT', response.data.root)
      return response
    },
    async searchTrialBalanceReport({commit}, toDate) {
      let response = await Api.request('get', '/finalReport/trailBalance/' + this.getters.organisationId + '/' + this.getters.fyId + '/' + toDate)
      commit('TRIALBALNCEREPORT', response.data.root)
      return response
    },
    async searchTradingReport({commit}, toDate) {
      let response = await Api.request('get', '/finalReport/tradingReport/' + this.getters.organisationId + '/' + this.getters.fyId + '/' + toDate)
      commit('TRIALBALNCEREPORT', response.data.root)
      return response
    },
    async searchBalanceSheetReport({commit}, toDate) {
      let response = await Api.request('get', '/finalReport/balanceSheet/' + this.getters.organisationId + '/' + this.getters.fyId + '/' + toDate)
      // commit('BALANCESHEETREPORT', response.data.root)
      return response
    },
    async loadDayBookList ({commit}, journal) {
      let response = await Api.request('get', '/accountingReport/dayBookWithCash/' +
      this.state.organisationid + '/' + journal.accountMasterId + '/' +
          this.state.fyId + '/' + journal.fromDate + '/' + journal.toDate + '/')
      let responseValue = response.data.data
      commit('JOURNAL_BOOK_LIST', responseValue)
      return response
    },
    async searchTrialBalanceOpeningReport({commit}, toDate) {
      let response = await Api.request('get', '/finalReport/trailBalanceOpening/' + this.getters.organisationId + '/' + this.getters.fyId + '/' + toDate)
      // commit('TRIALBALNCEREPORT', response.data.root)
      return response
    },
    async deleteJournal({commit}, data) {
      let response = await Api.request('delete', '/transactionMaster/deleteTransaction/' + data.tranId +
        '/' + data.tranModuleType + '/' + this.getters.fyId + '/' + this.getters.userId + '/' + this.getters.organisationId + '/' + data.deleteReason)
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_JOURNAL_ENTRY', response.data.data)
      }
      return response
    },
    async deleteReceipt({commit}, data) {
      let response = await Api.request('delete', '/transactionMaster/deleteTransaction/' + data.tranId +
        '/' + data.tranModuleType + '/' + this.getters.fyId + '/' + this.getters.userId + '/' + this.getters.organisationId + '/' + data.deleteReason)
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_RECEIPT_ENTRY', response.data.data)
      }
      return response
    },
    async deletePayment({commit}, data) {
      let response = await Api.request('delete', '/transactionMaster/deleteTransaction/' + data.tranId +
        '/' + data.tranModuleType + '/' + this.getters.fyId + '/' + this.getters.userId + '/' + this.getters.organisationId + '/' + data.deleteReason)
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_PAYMENT_ENTRY', response.data.data)
      }
      return response
    },
    async deleteCashDeposit({commit}, data) {
      let response = await Api.request('delete', '/transactionMaster/deleteTransaction/' + data.tranId +
        '/' + data.tranModuleType + '/' + this.getters.fyId + '/' + this.getters.userId + '/' + this.getters.organisationId + '/' + data.deleteReason)
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_CASH_DEPOSIT', response.data.data)
      }
      return response
    },
    async deleteCashWithdraw({commit}, data) {
      let response = await Api.request('delete', '/transactionMaster/deleteTransaction/' + data.tranId +
        '/' + data.tranModuleType + '/' + this.getters.fyId + '/' + this.getters.userId + '/' + this.getters.organisationId + '/' + data.deleteReason)
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_CASH_WITHDRAW', response.data.data)
      }
      return response
    },
    async deleteBankTransfer({commit}, data) {
      let response = await Api.request('delete', '/transactionMaster/deleteTransaction/' + data.tranId +
        '/' + data.tranModuleType + '/' + this.getters.fyId + '/' + this.getters.userId + '/' + this.getters.organisationId + '/' + data.deleteReason)
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_BANK_TRANSFER', response.data.data)
      }
      return response
    },
    async updatePaymentEntry({commit}, entry) {
      let response = await Api.request('put', '/transactionMaster/updateTransaction/' + this.state.user.id + '/' + this.state.fyId + '/' + this.getters.organisationId, entry, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_PAYMENT_ENTRY', response)
      }
      return response
    },
    async updateJournalEntry({commit}, entry) {
      let response = await Api.request('put', '/transactionMaster/updateTransaction/' + this.state.user.id + '/' + this.state.fyId + '/' + this.getters.organisationId, entry, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_JOURNAL_ENTRY', response)
      }
      return response
    },
    async updateReceiptEntry({commit}, entry) {
      let response = await Api.request('put', '/transactionMaster/updateTransaction/' + this.state.user.id + '/' + this.state.fyId + '/' + this.getters.organisationId, entry)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_RECEIPT_ENTRY', response)
      }
      return response
    },
    async updateBankTransfer({commit}, entry) {
      let response = await Api.request('put', '/transactionMaster/updateTransaction/' + this.state.user.id + '/' + this.state.fyId + '/' + this.getters.organisationId, entry)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_BANK_TRANSFER', response)
      }
      return response
    },
    async updateCashDeposit({commit}, entry) {
      let response = await Api.request('put', '/transactionMaster/updateTransaction/' + this.state.user.id + '/' + this.state.fyId + '/' + this.getters.organisationId, entry)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_CASH_DEPOSIT', response)
      }
      return response
    },
    async updateCashWithdraw({commit}, entry) {
      let response = await Api.request('put', '/transactionMaster/updateTransaction/' + this.state.user.id + '/' + this.state.fyId + '/' + this.getters.organisationId, entry)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_CASH_WITHDRAW', response)
      }
      return response
    },
    async supplierOutstandingReport({commit}, toDate) {
      let response = await Api.request('get', '/accountingReport/outstandingReport/' + this.getters.organisationId + '/' + this.state.fyId + '/' + toDate + '/supplier')
      if (response.data.status === 'SUCCESS') {
        // commit('SUPPLIER_OUTSTANDING_REPORT', response)
      } return response
    },
    async customerOutstandingReport({commit}, toDate) {
      let response = await Api.request('get', '/accountingReport/outstandingReport/' + this.getters.organisationId + '/' + this.state.fyId + '/' + toDate + '/customer')
      if (response.data.status === 'SUCCESS') {
        // commit('CUSTOMER_OUTSTANDING_REPORT', response)
      }
      return response
    },
    async bankClosingExcludingOverDraft({commit}) {
      let response = await Api.request('get', '/accountingReport/bankClosingBalance/' + this.getters.organisationId + '/' + this.state.fyId + '/excluding')
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async bankClosingIncludingOverDraft({commit}) {
      let response = await Api.request('get', '/accountingReport/bankClosingBalance/' + this.getters.organisationId + '/' + this.state.fyId + '/including')
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async bankClosingOnlyOverDraft({commit}) {
      let response = await Api.request('get', '/accountingReport/bankClosingBalance/' + this.getters.organisationId + '/' + this.state.fyId + '/only')
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    // ReverseTransaction Api
    async reverseJournalTransaction({commit}, transactionData) {
      let response = await Api.request('put', '/transactionMaster/saveReversalEntry/' + this.getters.organisationId + '/' + this.getters.userId + '/' + this.state.fyId, transactionData)
      if (response.data.status === 'SUCCESS') {
        commit('ALL_JOURNAL_BOOK_LIST', response.data.data)
      }
      return response
    },
    async updateTranId({commit}, data) {
      let response = await Api.request('put', '/transactionMaster/updateTranId/' + data.id)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_TRANSACTIONID', response.data.data)
        return response
      }
    },
    async updateTransactionStatus({commit}, data) {
      let response = await Api.request('put', '/transactionMaster/updateTransactionTypeMakerChecker/' + data.tranId +
        '/' + data.tranModuleType + '/' + this.getters.fyId + '/' + this.getters.userId + '/' + this.getters.organisationId + '/' + data.deleteReason + '/' + data.statusType)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_TRANSACTION_STATUS', response.data.data)
      }
      return response
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/accountingReport.js